import { useLayoutEffect, useRef } from 'react';
import styled from 'styled-components';

const Wrapper = styled.label`
  display: inline-block;
  position: relative;
  min-width: 1.42em;
  min-height: 1.42em;
  line-height: 1.42em;
  cursor: pointer;
  font-size: ${(props) => props.size}px;

  span {
    display: inline-block;
    padding-left: 2em;
    color: #666;
  }

  div {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #dedede;
    border-radius: 2px;
    background: white;
    height: 1.42em;
    width: 1.42em;
    transition: 0.2s ease all;
  }

  &:hover input:not([disabled]) ~ div {
    border-color: #aaaaaa;
  }

  input {
    display: none;

    &:checked ~ div {
      border-color: transparent;

      &::after {
        content: '';
        display: block;
        border: solid #ffffff;
        border-width: 0 2px 2px 0;
        width: 0.35em;
        height: 0.64em;
        margin: 0.25em 0 0 0.54em;
        position: absolute;
        top: 22%;
        left: 10%;
        transform: translate(-50%, -50%) rotate(45deg);
      }
    }

    &:checked:not([disabled]) ~ div {
      background-color: #ff922d;
    }

    &:indeterminate ~ div {
      border-color: transparent;

      &::after {
        content: '';
        display: block;
        border: solid #ff922d;
        border-radius: 2px;
        border-width: 6px;
        width: 0.8em;
        height: 0.8em;
        position: absolute;
        top: 17%;
        left: 14%;
      }
    }

    &:checked:not([disabled]) ~ div {
      background-color: #ff922d;
    }

    &[disabled] ~ div {
      border-color: transparent;
      background-color: #aaaaaa;
      cursor: not-allowed;
    }

    &[disabled]:checked ~ div {
      &::after {
        border-color: #828282;
      }
    }

    &[disabled]:indeterminate ~ div {
      &::after {
        border-color: #828282;
      }
    }
  }
`;

/**
 * @deprecated use Checkbox from '@frontend/components' instead.
 */
const Checkbox = (props) => {
  const { children, id, indeterminate, size = 14, ...rest } = props;

  const checkboxRef = useRef();
  useLayoutEffect(() => {
    const checkboxElement = checkboxRef.current;
    if (checkboxElement) {
      checkboxElement.indeterminate = !!indeterminate;
    }
  }, [indeterminate]);

  return (
    <Wrapper data-testid="checkbox" size={size}>
      <input type="checkbox" id={id} ref={checkboxRef} {...rest} />
      {children ? <span>{children}</span> : null}
      <div />
    </Wrapper>
  );
};

export default Checkbox;
